<template>
  <div
    class="group flex items-center cursor-pointer my-1 hover:bg-gray-300 py-2 px-5 text-left"
    :class="[
      
    ]"
    @click="$emit('select', item)"
  >
    <!-- Muestra la imagen solo si item.image existe o es una cadena vacía -->
    <img
      v-if="item.image !== undefined && item.image !== null"
      :src="resolvedImage"
      @error="loadDefaultImg"
      class="object-cover h-12 w-12 rounded-full animation-border"
      :class="[
        item.inactive ? 'border-solid border-2 border-cdmx-red' : 'border-solid border-2 border-cdmx-green', 
      ]"
    />

    <div class="flex flex-col ml-2">
      <span
        class="group-hover:text-gray-900" 
        :class="[item.is_admin ? 'font-semibold' : '']"
      >
        {{ item.title }}
        <span
          v-if="item.is_admin"
        >*</span>
      </span>
      <span
        class="text-sm group-hover:text-gray-700" 
      >
        {{ item.subtitle }}
      </span>
      <span
        v-if="item.description"
        class="text-sm group-hover:text-gray-700" 
      >
        {{ item.description }}
      </span>
    </div>
  </div>
</template>

<script>


import defaultProfileImg from "@/assets/default-profile.png";

export default {
  name: "BaseListItem",
  props: {
    item: { type: Object, required: true }, 
    selectedId: { type: [String, Number], default: null },
  },
  computed: {
    resolvedImage() {
      // Si el valor es una cadena vacía "", usar imagen por defecto
      if (this.item.image === "") {
        return defaultProfileImg;
      }
      // Si es una URL o ruta válida, usarla
      return this.item.image;
    },

    isSelected() {
      return this.selectedId === this.item.id;
    },
  },
  methods: {
    loadDefaultImg(event) {
      event.target.src = defaultProfileImg;
    },

    
  },
};
</script> 